import React from 'react';
import { ChevronRight } from 'lucide-react';

const LegalAccordionPage = ({ title, description, children }) => (
  <div className="min-h-screen w-full bg-[#f6f8f7] px-5 py-16 font-[Inter,sans-serif] sm:px-6 max-[520px]:py-9">
    <div className="mx-auto w-full max-w-[800px]">
      <header className="mb-[35px] px-5 max-[520px]:mb-7 max-[520px]:px-2.5">
        <h1 className="text-[32px] font-semibold leading-[1.3] tracking-[-0.65px] text-[#24382c] max-[520px]:text-[27px]">
          {title}
        </h1>
        {description && <p className="mt-3 text-sm leading-[1.6] text-[#687b6e]">{description}</p>}
      </header>

      <nav>
        <ol className="border-t border-[#cdd9d0]">{children}</ol>
      </nav>
    </div>
  </div>
);

const LegalAccordionRow = ({ id, title, isOpen, onToggle, children }) => (
  <li className="border-b border-[#dce4df]">
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={isOpen}
      aria-controls={id}
      className="flex min-h-[62px] w-full items-center justify-between gap-6 px-5 py-[18px] text-left text-sm leading-[1.55] text-[#344f3d] transition-colors hover:bg-[#eef3ef] hover:text-[#267147] aria-expanded:font-semibold aria-expanded:text-[#2a7245] max-[520px]:gap-5 max-[520px]:px-2.5"
    >
      <span>{title}</span>
      <ChevronRight
        className={`h-[17px] w-[17px] shrink-0 text-[#708677] transition-transform duration-300 ${
          isOpen ? 'rotate-90' : 'rotate-0'
        }`}
        aria-hidden="true"
      />
    </button>
    {isOpen && (
      <section
        id={id}
        className="mx-5 mb-6 space-y-4 py-2 pr-5 text-sm leading-7 text-[#607165] max-[520px]:mx-2.5 max-[520px]:pr-0"
      >
        {children}
      </section>
    )}
  </li>
);

export { LegalAccordionPage, LegalAccordionRow };
